import { apiPost } from '../axios.config'
import { API_ROUTES } from '../routes'
import { useMutationHook } from './mutationHook'

interface IDeleteAgreementParams {
  id: string
}

async function fetchDeleteAgreement(path: string, body: IDeleteAgreementParams) {
  const { data } = await apiPost<IDeleteAgreementParams, void>({ path, body })

  return data
}

export const useDeleteAgreement = () => {
  const path = API_ROUTES.AGREEMENT_DELETE
  const mutationFn = (url: string, body: IDeleteAgreementParams) => fetchDeleteAgreement(url, body)
  const mutationFunc = useMutationHook({ path, mutationFn })

  return mutationFunc
}
